var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 0.56543H14.373C14.6973 0.56543 14.908 0.906963 14.7617 1.19629L13.6309 3.43262C13.5568 3.57893 13.4062 3.6709 13.2422 3.6709H6.75C5.6645 3.6709 4.98645 4.84671 5.53027 5.78613L8.1875 10.377C8.35766 10.6711 8.14048 11.0377 7.80078 11.0293L5.16211 10.9639C4.65202 10.9511 4.18657 10.6686 3.94043 10.2217L1.50293 5.79492C0.95706 4.80358 0.920223 3.6103 1.40332 2.58691C1.9861 1.3526 3.22878 0.565438 4.59375 0.56543Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9264 11.0178L12.25 6.39505C11.9184 5.82235 11.3068 5.46973 10.6451 5.46973C9.21651 5.46973 8.32439 7.01705 9.04016 8.25338L10.9807 11.6052C11.3065 12.168 10.9004 12.8723 10.2501 12.8723H4.20985C3.54947 12.8723 2.93913 13.2242 2.60825 13.7957C1.89397 15.0295 2.78424 16.5736 4.20985 16.5736H11.7232C13.0439 16.5736 14.2646 15.8698 14.9264 14.7268C15.5905 13.5797 15.5905 12.165 14.9264 11.0178Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.40172e7798044cda087347d668161ed8.svg";
export { ForwardRef as ReactComponent };